import React, { Component } from 'react';
import { connect } from 'react-redux';
import HomeSubListWrap from '../../views/widget/home/sub/list/HomeSubListWrap';
import { widgetActions } from '../../store/modules/widget';
import { SUB_PAGE_LIST_SEARCH_OPTION_MODEL, SUB_PAGE_LIST_SEARCH_DATA_MODEL } from '../../store/modules/widget/models';
import { _LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import { asyncSimpleModal } from '../../lib/common';
import { HOME_STATUS } from '../../constants/service/app/widgetConstants';

class SubPageListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = () => {
    const { setData } = this.props;

    this.getList({
      searchOption: SUB_PAGE_LIST_SEARCH_OPTION_MODEL,
      pagination: _LIST_PAGINATION_MODEL,
    });

    /**
     * 검색 박스 초기화
     */
    setData({
      path: ['subPageList', 'searchData'],
      value: SUB_PAGE_LIST_SEARCH_DATA_MODEL,
    });
  };

  /**
   * 리스트 불러오기
   */
  getList = async (data) => {
    const { getSubPageList, subPageList } = this.props;
    const { searchOption, pagination } = subPageList;

    getSubPageList({
      searchOption,
      pagination,
      ...data,
    });
  };

  /**
   *  서브 페이지 상태 업데이트하기
   */
  updateSubPageStatus = async (data) => {
    const { updateSubPageStatus } = this.props;
    const { linkedHomeMenu, linkedHomeTab, subPageId, status, index } = data;

    if (linkedHomeMenu || linkedHomeTab) {
      await asyncSimpleModal({
        type: 'error',
        title: '활성화 편집',
        message: `링크된 메뉴가 있는 경우, 비활성화가 불가능합니다.`,
      });
      return;
    }

    const confirmResult = await asyncSimpleModal({
      type: 'confirm',
      title: '페이지 상태 변경',
      message: `해당 페이지를 ${status ? '활성' : '비활성'}으로 변경하시겠습니까?`,
    });

    if (!confirmResult) return;

    updateSubPageStatus({
      subPageId,
      status,
      index,
    });
  };

  /**
   *  서브 페이지 삭제하기
   */
  deleteSubPage = async (data) => {
    const { deleteSubPage } = this.props;
    const { subPageId } = data;

    const confirmResult = await asyncSimpleModal({
      type: 'confirm',
      title: '페이지 삭제',
      message: '해당 페이지를 삭제합니다. 계속 진행하시겠습니까?',
    });

    if (!confirmResult) return;

    deleteSubPage({
      subPageId,
      status: HOME_STATUS.DELETE,
    });
  };

  render() {
    const { subPageList, setData } = this.props;

    return (
      <HomeSubListWrap
        subPageList={subPageList}
        setData={setData}
        getList={this.getList}
        updateSubPageStatus={this.updateSubPageStatus}
        deleteSubPage={this.deleteSubPage}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    subPageList: state.widget.subPageList,
  };
};

const mapDispatchToProps = {
  setData: widgetActions.setData,
  getSubPageList: widgetActions.getSubPageList,
  updateSubPageStatus: widgetActions.updateSubPageStatus,
  deleteSubPage: widgetActions.deleteSubPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(SubPageListContainer);
